








































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component
export default class NavBarLink extends Vue {

  @Prop({ required: true })
  routeName!: string;

  @Prop({ required: true })
  text!: string;

  @Prop() selected!: boolean;

  @Prop({ default: 'icon-empty' })
  iconName!: string;

  @Prop({ default: false })
  row!: boolean;
}
